export const FFDefaults: Record<string, boolean> = {
  test_flag: false
};
